/* eslint-disable */

import React, { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import * as Yup from "yup";
import moment from "moment";

import MakeAPICall from "../../apiCalls/common";
import ICCheckbox from "../../components/form/checkbox";

import {
  checkDuplicatePatientDemographicInfoApiRoute,
  checkIfMedicareCardDuplicateExistsApiRoute,
  checkIsDuplicateIHINumberApiRoute,
  editPatProfileApiRoute,
  getIHIHistoryRecordApiRoute,
  requestHIServiceSearchIHIApiRoute,
  resetPatientPassword,
  verifyPatientByMedicareOnlineApiRoute
} from "../../apiRoutes";

import { getFormattedDate, getFormattedMonthDateV2 } from "../../utils/dateTimeHelper";
import HIServiceUtil from "../../utils/HIServiceUtil";

import { checkIsMedicareCheckDigitValid } from "../../utils/MedicareCardUtil";

import { IMAGES_FORMATS, MAX_FILE_SIZE, phoneRegex } from "../../constants/constants";

import { checkEmptyElementInObj, formatName } from "../../utils/commonMethods";

import VerifyMedicareCardResponse from "../../containers/PRODAInterface/verifyMedicareCardResponse";
import VerifyMedicareCardFailedResponse from "../../containers/PRODAInterface/verifyMedicareCardFailedResponse";
import IHIHistoryRecord from "../../containers/HIServiceInterface/IHIHistoryRecord";
import IHISearchDropdown from "../../containers/HIServiceInterface/IHISearchDropdown";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import ICPhoneInput from "../../components/form/phoneInput";
import Loader from "../../components/loader";
import CustomMaskInput from "../../components/form/customMaskInput";
import RefreshButton from "../../components/refreshButton";
import LockedButton from "../../components/lockedButton";
import LockOpenButton from "../../components/lockOpenButton";
import HistoryRecordButton from "../../components/historyRecordButton";
import CustomModal from "../../components/modal";

import HIServiceType from "../../constants/HI_API";

const PatientProfileForm = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [serverErrorMsg, setServerErrorMsg] = useState("");
  const [fileError, setFileError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [verifyMedicareCardModal, setVerifyMedicareCardModal] = useState(false);
  const [medicareStatus, setMedicareStatus] = useState(null);
  const [lastVerificationDate, setLastVerificationDate] = useState(null);
  const [lastVerificationCode, setLastVerificationCode] = useState(null);
  const [
    patientVerificationFailedRes,
    setPatientVerificationFailedRes
  ] = useState(null);
  const [
    patientVerificationFailedModal,
    setPatientVerificationFailedModal
  ] = useState(false);
  const [IHIHistoryRecordModal, setIHIHistoryRecordModal] = useState(false);
  const [IHIHistoryRecordData, setIHIHistoryRecordData] = useState(null);
  const [HILocked, setHILocked] = useState(true);
  const [IHINumberDuplicateModal, setIHINumberDuplicateModal] = useState(false);
  const [
    IHINumberDuplicateModalText,
    setIHINumberDuplicateModalText
  ] = useState("");
  const [multiIHISearch, setMultiIHISearch] = useState(false);
  const [isMedicareCheckDigitValid, setIsMedicareCheckDigitValid] = useState(
    true
  );
  const [isHIServiceInvoked, setIsHIServiceInvoked] = useState(false);
  const [initProfileForHIService, setInitProfileForHIService] = useState({});
  const [profileUsedForHIService, setProfileUsedForHIService] = useState({});
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showSeparateModal, setShowSeparateModal] = useState(false);
  const [separateDependent, setSeparateDependent] = useState(false);

  // set fields enable or disable based on dependent age (if current patient is dependent);
  const [isFieldsDisabled, setIsFieldsDisabled] = useState(false);

  // initial
  useEffect(() => {
    if (props.data && props.data.verificationByMedicareOnlineUpdatedAt) {
      let date = new Date(props.data.verificationByMedicareOnlineUpdatedAt);
      date = date.toLocaleString("fr-CA").split(" ")[0];
      date = date.replace(/,/, "");
      setLastVerificationDate(date);
    }
    if (props.data) {
      setLastVerificationCode(props.data.verificationByMedicareOnlineCode);
    }

    // check for dependent and dob for patient
    // if patient dob is greater then 18 and is dependent then we will allow to edit disabled fields like phoneNo, email,...
    if (props.data && props.data.isDependent === true) {
      checkPatientOver18(true, props.data.dateOfBirth);
    }
  }, [props.data]);

  // record init profile for HI Service
  useEffect(() => {
    const fname = props.data ? props.data.firstName : "";
    const mname = props.data ? props.data.middleName : "";
    const lname = props.data ? props.data.lastName : "";
    let dob = props.data ? formatDate(props.data.dateOfBirth) : new Date();
    dob = getFormattedDate(dob);
    const gender = props.data ? props.data.gender : "";
    const medNo = props.data ? props.data.medicareNumber : "";
    const refNo = props.data ? props.data.refNumerOnMedicareCard : "";
    // const DVANumber =
    //   props.data && props.data.DVANumber ? props.data.DVANumber : "";
    const firstNameForHIService = props.data?.firstNameForHIService
      ? props.data.firstNameForHIService
      : props.data.firstName;
    const lastNameForHIService = props.data?.lastNameForHIService
      ? props.data.lastNameForHIService
      : props.data.lastName;
    setInitProfileForHIService({
      fname: firstNameForHIService,
      lname: lastNameForHIService,
      gender,
      dob,
      medNo,
      refNo
      // DVANumber
    });
  }, []);

  const formatDate = date => {
    const is_validDate = date.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    return is_validDate ? getFormattedMonthDateV2(date) : "";
  };

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      profilePic: null,
      uin: props.data ? props.data.patientId : "",
      fname: props.data ? props.data.firstName : "",
      mname: props.data ? props.data.middleName : "",
      lname: props.data ? props.data.lastName : "",
      dob: props.data ? formatDate(props.data.dateOfBirth) : new Date(),
      gender: props.data ? props.data.gender : "",
      previewImg: props.data ? props.data.profilePicOri : "",
      phoneNo: props.data ? props.data.phoneNumber : "",
      email: props.data ? props.data.email : "",
      regDate: props.data ? props.data.registrationDate : "",
      ccn: props.data ? props.data.patientCards : [],
      un: props.data ? props.data.streetNumber : "",
      streetName: props.data ? props.data.streetName : "",
      suburb: props.data ? props.data.suburb : "",
      state: props.data ? props.data.state : "",
      postCode: props.data ? props.data.postCode : "",
      medNo: props.data ? props.data.medicareNumber : "",
      refNo: props.data ? props.data.refNumerOnMedicareCard : "",
      ecName1: props.data ? props.data.contactName : "",
      ecNumber1: props.data ? props.data.contactContact : "",
      ecName2: props.data ? props.data.contactName2 : "",
      ecNumber2: props.data ? props.data.contactContact2 : "",
      notes: props.data ? props.data.additionalInfo : "",
      IHIRecordStatus:
        props.data && props.data.IHIInfo
          ? props.data.IHIInfo.IHIRecordStatus
            ? props.data.IHIInfo.IHIRecordStatus
            : ""
          : "",
      IHINumberStatus:
        props.data && props.data.IHIInfo
          ? props.data.IHIInfo.IHINumberStatus
            ? props.data.IHIInfo.IHINumberStatus
            : ""
          : "",
      IHINumber:
        props.data && props.data.IHIInfo
          ? props.data.IHIInfo.IHINumber
            ? props.data.IHIInfo.IHINumber
            : ""
          : "",
      IHIUpdateAt:
        props.data && props.data.IHIInfo ? props.data.IHIInfo.updatedAt : "",
      optOutMarketingEmails:
        props.data && props.data.optOutMarketingEmails === true ? true : false,
      // DVANumber: props.data && props.data.DVANumber ? props.data.DVANumber : "",
      firstNameForHIService: props.data?.firstNameForHIService
        ? props.data.firstNameForHIService
        : props.data?.firstName
          ? props.data.firstName
          : "",
      lastNameForHIService: props.data?.lastNameForHIService
        ? props.data.lastNameForHIService
        : props.data?.lastName
          ? props.data.lastName
          : ""
    },
    validationSchema: Yup.object({
      fname: Yup.string()
        // .min(1, "First name must be of minimum length 1")
        // .max(25, "First name cannot be greater than 25 characters")
        .required("Please enter first name"),
      lname: Yup.string()
        // .min(1, "Last name must be of minimum length 1")
        // .max(25, "Last name cannot be greater than 25 characters")
        .required("Please enter last name"),
      dob: Yup.mixed().required("Please select date of birth"),
      gender: Yup.string().required("Please select gender"),
      state: Yup.string().required("Please select state"),
      phoneNo: Yup.string()
        .required("Please enter phone no")
        .matches(phoneRegex, "Please enter correct phone no"),
      email: Yup.string()
        .min(7, "Email must be of minimum length 7")
        .email("Please provide a valid email address")
        .required("Please enter email"),
      un: Yup.string().required("Please enter street number"),
      streetName: Yup.string().required("Please enter street name"),
      suburb: Yup.string().required("Please enter suburb"),
      postCode: Yup.string().required("Please enter postcode"),
      IHIRecordStatus: Yup.string(),
      IHINumberStatus: Yup.string(),
      IHINumber: Yup.string().matches(/^[0-9]{16}$/, "Please enter 16 digits"),
      IHIUpdateAt: Yup.string(),
      // DVANumber: Yup.string(),
      medNo: Yup.string().matches(
        /(^$)|[2-6]{1}[0-9]{3}\s?[0-9]{5}\s?[0-9]{1}/,
        "Please enter 10 digits, with 1st digit ranging from 2 to 6"
      ),
      firstNameForHIService: Yup.string().required(
        "Please enter first name for HIService"
      ),
      lastNameForHIService: Yup.string().required(
        "Please enter last name for HI Service"
      )
    }),
    onSubmit: values => {
      console.log(initProfileForHIService);
      console.log(profileUsedForHIService);
      const isProfileChangedAfterHIService = checkIsProfileChangedAfterHIService();
      if (!isMedicareCheckDigitValid && formik.values.medNo) {
        setShowModal(true);
        setModalText(
          "The check digit of Medicare Card Number is invalid. Please correct it or remove it."
        );
      } else if (isProfileChangedAfterHIService) {
        setShowModal(true);
        setModalText(
          "The criteria of HI Service have been changed. Please check IHI again or restore the profile the same as before HI Service."
        );
      } else {
        console.log("Values here: ", values);
        callEditPatientApi(values);
      }
    }
  });

  const newEmailFormik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      newEmail: ""
    }, validationSchema: Yup.object({
      newEmail: Yup.string()
        .min(7, "Email must be of minimum length 7")
        .email("Please provide a valid email address")
        .required("Please enter email")
    }), onSubmit: async (values) => {
        await formik.validateForm();
        setShowSeparateModal(false)

        if (Object.values(newEmailFormik.errors).length) {
          setModalText("Please make sure the form is filled correctly.");
          setShowModal(true);
        } else {
          callEditPatientApi(formik.values, values.newEmail);
        }
    }
  });

  const checkIsProfileChangedAfterHIService = () => {
    if (!isHIServiceInvoked) {
      return false;
    } else {
      if (
        profileUsedForHIService.fname ===
        (formik.values.firstNameForHIService || formik.values.fname) &&
        profileUsedForHIService.lname ===
        (formik.values.lastNameForHIService || formik.values.lname) &&
        profileUsedForHIService.dob === getFormattedDate(formik.values.dob) &&
        profileUsedForHIService.gender === formik.values.gender &&
        profileUsedForHIService.medNo === formik.values.medNo &&
        profileUsedForHIService.refNo === formik.values.refNo
        // profileUsedForHIService.DVANumber === formik.values.DVANumber
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  // validate MedicareCard Number check digit
  useEffect(() => {
    if (formik.values.medNo) {
      const medNo = formik.values.medNo;
      if (typeof medNo === "string") {
        const cardNum = medNo.replace(/\s+/g, "");
        if (cardNum.length === 10) {
          const isCheckDigitValid = checkIsMedicareCheckDigitValid(cardNum);
          setIsMedicareCheckDigitValid(isCheckDigitValid);
          if (!isCheckDigitValid) {
            setModalText("The check digit of Medicare Card Number is invalid");
            setShowModal(true);
          }
        }
      }
    }
  }, [formik.values.medNo]);

  // validate MedicareCard Number check digit
  useEffect(() => {
    console.log("useEffect formik.values.IHINumber", formik.values.IHINumber);
    if (formik.values.IHINumber) {
      let IHINumber = formik.values.IHINumber;
      if (typeof IHINumber === "string") {
        IHINumber = IHINumber.replace(/\s+/g, "");
        if (IHINumber.length === 16) {
          const isCheckDigitValid = HIServiceUtil.checkIsValidCheckDigit(
            IHINumber
          );
          if (!isCheckDigitValid) {
            setModalText("The check digit of IHI Number is invalid.");
            setShowModal(true);
          }
        }
      }
    }
  }, [formik.values.IHINumber]);

  // check patient is over 18 years or not and dependent on that, enable or disable fields
  useEffect(() => {
    if (props.data && props.data.isDependent === true) {
      let dob = getFormattedDate(formik.values.dob);
      checkPatientOver18(true, dob);
    }
  }, [formik.values.dob]);

  // validate input file
  const validateFile = file => {
    setFileError("");
    if (file) {
      if (file.size >= MAX_FILE_SIZE) {
        setFileError("Maximum 2MB file is allowed");
        return false;
      } else if (!IMAGES_FORMATS.includes(file.type)) {
        setFileError(
          "File must be one of these formats only jpg, jpeg, png, svg or gif"
        );
        return false;
      }
    }
    return true;
  };

  const checkForDuplicateAttachment = values => {
    if (
      props.data._id &&
      values.medNo &&
      values.medNo !== "" &&
      values.refNo &&
      values.refNo !== ""
    ) {
      let medicareNumber = values.medNo;
      if (values.medNo.length > 10) {
        // remove space in medicareNumber
        medicareNumber = medicareNumber.replace(/\s+/g, "");
      }

      let formData = new FormData();
      formData.append("patientId", props.data._id);
      formData.append("medicareNumber", medicareNumber);
      formData.append("refNumerOnMedicareCard", values.refNo);

      setIsProcessing(true);
      setApiCallParams({
        reqType: "POST",
        reqUrl: checkIfMedicareCardDuplicateExistsApiRoute,
        dataObj: formData,
        successCallback: res => {
          setIsProcessing(false);
          if (res.data.data === "No duplicate found") {
            verifyMedicareCard(values);
          } else {
            setModalText(
              "Patient's Medicare details are already registered with<br /> Patient UIN: " +
              res.data.data.patientId +
              "<br />Please remove the duplicate account,<br /> or obtain correct Medicare details."
            );
            setShowModal(true);
          }
        },
        failureCallback: err => {
          setIsProcessing(false);
          //setServerErrorMsg(err.message);
        }
      });
    } else {
      verifyMedicareCard(values);
    }
  };

  // verify patient's medicare card info
  const verifyMedicareCard = values => {
    let medicareNumber = values.medNo;
    if (values.medNo.length > 10) {
      // remove space in medicareNumber
      medicareNumber = medicareNumber.replace(/\s+/g, "");
    }

    const formData = new FormData();
    formData.append("_id", props.data._id);
    formData.append("firstName", values.firstNameForHIService);
    formData.append("lastName", values.lastNameForHIService);
    formData.append("dateOfBirth", getFormattedDate(values.dob));
    formData.append("gender", values.gender);
    formData.append("medicareNumber", medicareNumber);
    formData.append("refNumerOnMedicareCard", values.refNo);

    setIsProcessing(true);
    setApiCallParams({
      reqType: "POST",
      reqUrl: verifyPatientByMedicareOnlineApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        const medicareStatus = res.data.data.medicareStatus;
        if (medicareStatus) {
          let date = new Date();
          date = date.toLocaleString("fr-CA").split(" ")[0];
          date = date.replace(/,/, "");
          setLastVerificationDate(date);
          setLastVerificationCode(medicareStatus.status.code);
          setMedicareStatus(medicareStatus);
          setVerifyMedicareCardModal(true);
        } else {
          setPatientVerificationFailedRes(res.data.data);
          setPatientVerificationFailedModal(true);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setServerErrorMsg(err.message);
      }
    });
  };

  const callEditPatientApi = (values, newEmail) => {
    console.log({values, newEmail});
    let formData = new FormData();
    let image_flag = false;

    if (values.profilePic !== null) {
      formData.append("profilePhoto", values.profilePic);
      image_flag = true;
    }

    formData.append("isFile", image_flag);

    let kin1 = {};
    let kin2 = {};
    if (values.ecName1 && !values.ecNumber1) {
      kin1.name = values.ecName1;
      formData.append("kin1", JSON.stringify(kin1));
    }
    if (!values.ecName1 && values.ecNumber1) {
      kin1.contact = values.ecNumber1;
      formData.append("kin1", JSON.stringify(kin1));
    }
    if (values.ecName2 && !values.ecNumber2) {
      kin2.name = values.ecName2;
      formData.append("kin2", JSON.stringify(kin2));
    }
    if (!values.ecName2 && values.ecNumber2) {
      kin2.contact = values.ecNumber2;
      formData.append("kin2", JSON.stringify(kin2));
    }
    if (values.ecName1 && values.ecNumber1) {
      kin1.name = values.ecName1;
      kin1.contact = values.ecNumber1;
      formData.append("kin1", JSON.stringify(kin1));
    }
    if (values.ecName2 && values.ecNumber2) {
      kin2.name = values.ecName2;
      kin2.contact = values.ecNumber2;
      formData.append("kin2", JSON.stringify(kin2));
    }

    formData.append("isDependent", props.data.isDependent); // original value of isDependent - we will check email & isDependent & years of dob in backend to verify 
    formData.append("patient_id", props.data._id);
    formData.append("firstName", formatName(values.fname));
    formData.append("middleName", formatName(values.mname));
    formData.append("lastName", formatName(values.lname));
    formData.append("dateOfBirth", getFormattedDate(values.dob));
    formData.append("gender", values.gender);
    formData.append("phoneNumber", values.phoneNo.replace(/\s/gi, ""));
    if (values.un.includes("/")) {
      let spl = values.un.split("/");
      formData.append("unitNumber", spl[0]);
      formData.append("streetNumber", spl[1]);
    } else {
      formData.append("unitNumber", "");
      formData.append("streetNumber", values.un);
    }

    // formData.append("wantToSeparate", values.streetName);
    formData.append("wantToSeperate", !!newEmail);

    formData.append("streetName", values.streetName);
    formData.append("suburb", values.suburb);
    formData.append("email", newEmail || values.email);
    formData.append("state", values.state);
    formData.append("postCode", values.postCode);
    formData.append("medicareNumber", values.medNo ? values.medNo : "");
    formData.append("refNumerOnMedicareCard", values.refNo ? values.refNo : "");
    formData.append("additionalInfo", values.notes);
    formData.append("optOutMarketingEmails", values.optOutMarketingEmails);
    // formData.append("DVANumber", values.DVANumber);
    if (values.firstNameForHIService) {
      formData.append("firstNameForHIService", values.firstNameForHIService);
    }
    if (values.lastNameForHIService) {
      formData.append("lastNameForHIService", values.lastNameForHIService);
    }

    if (HILocked) {
      formData.append("IHINumber", values.IHINumber)
    }
    setIsProcessing(true);
    setApiCallParams({
      reqType: "PUT",
      reqUrl: editPatProfileApiRoute,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        props.successEvent();
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setServerErrorMsg(err.message);
      }
    });
  };

  // const searchIHI = values => {
  //   let medicareNumber = values.medNo;
  //   if (medicareNumber.length > 10) {
  //     // remove space in medicareNumber
  //     medicareNumber = medicareNumber.replace(/\s+/g, "");
  //   }
  //
  //   let IHINumber = values.IHINumber;
  //
  //   let streetNumber;
  //   if (values.un.includes("/")) {
  //     let spl = values.un.split("/");
  //     streetNumber = spl[1].trim();
  //   } else {
  //     streetNumber = values.un.trim();
  //   }
  //
  //   const IHIObj = IHINumber
  //     ? {
  //       firstName: values.firstNameForHIService,
  //       lastName: values.lastNameForHIService,
  //       DOB: getFormattedDate(values.dob),
  //       gender: values.gender,
  //       IHINumber: IHINumber
  //     }
  //     : medicareNumber
  //       ? {
  //         firstName: values.firstNameForHIService,
  //         lastName: values.lastNameForHIService,
  //         DOB: getFormattedDate(values.dob),
  //         gender: values.gender,
  //         medicareNumber: medicareNumber,
  //         medicareReferenceNumber: values.refNo
  //         // serviceType: HIServiceType.SEARCH_IHI
  //         // IHINumber: values.IHINumber || ""
  //       }
  //       : {
  //         firstName: values.firstNameForHIService || "",
  //         lastName: values.lastNameForHIService || "",
  //         DOB: getFormattedDate(values.dob) || "",
  //         gender: values.gender || "",
  //         state: values.state || "",
  //         postcode: values.postCode || "",
  //         suburb: values.suburb || "",
  //         streetNumber: streetNumber || "",
  //         streetName: values.streetName || ""
  //       };
  //
  //   // TODO: check if any field value is missing
  //   const emptyElementArray = checkEmptyElementInObj(IHIObj);
  //   if (emptyElementArray.length === 0) {
  //     IHIObj.patientID = props.data._id;
  //     IHIObj.serviceType = HIServiceType.SEARCH_IHI;
  //
  //     // IHIObj.IHINumber = values.IHINumber || "";
  //
  //     // const formData = new FormData();
  //     // formData.append("HIInfo", JSON.stringify(IHIObj));
  //     const dataToSend = {
  //       HIInfo: IHIObj
  //     };
  //
  //     setIsProcessing(true);
  //     setApiCallParams({
  //       reqType: "POST",
  //       reqUrl: requestHIServiceSearchIHIApiRoute,
  //       dataObj: dataToSend,
  //       successCallback: res => {
  //         setIsProcessing(false);
  //         if (
  //           res &&
  //           res.data &&
  //           res.data.data &&
  //           res.data.data.searchIHIResult
  //         ) {
  //           // get IHI number
  //           if (res.data.data.searchIHIResult.ihiNumber) {
  //             const { isSameAsDatabase, IHIUpdatedAt } = res.data.data;
  //             if (isSameAsDatabase) {
  //               formik.values.IHIUpdateAt = IHIUpdatedAt;
  //               setModalText("IHI details are the same as last update.");
  //               setModalTitle("IHI refreshed");
  //               setShowModal(true);
  //             } else {
  //               const {
  //                 ihiNumber,
  //                 ihiRecordStatus: IHIRecordStatus,
  //                 ihiStatus: IHINumberStatus
  //               } = res.data.data.searchIHIResult;
  //
  //               // const IHINumber = ihiNumber.split("/id/hi/ihi/1.0/")[1];
  //
  //               formik.values.IHINumber = IHINumber || "";
  //               formik.values.IHINumberStatus = IHINumberStatus;
  //               formik.values.IHIRecordStatus = IHIRecordStatus;
  //               formik.values.IHIUpdateAt = IHIUpdatedAt;
  //
  //               const formData = new FormData();
  //               formData.append("patientId", props.data._id);
  //               formData.append("IHINumber", IHINumber);
  //
  //               setIsProcessing(true);
  //               setApiCallParams({
  //                 reqType: "POST",
  //                 reqUrl: checkIsDuplicateIHINumberApiRoute,
  //                 dataObj: formData,
  //                 successCallback: res => {
  //                   setIsProcessing(false);
  //                   const result = res.data.data;
  //                   const duplicateIHICount = Object.keys(result).length;
  //                   if (duplicateIHICount > 0) {
  //                     let duplicateIHIPatientUIN = "";
  //                     result.map(item => {
  //                       duplicateIHIPatientUIN =
  //                         duplicateIHIPatientUIN + item.patientId + " ";
  //                     });
  //                     setModalTitle("Duplicate IHI Number");
  //                     setModalText(
  //                       "IHI details have been changed and saved. <br/>Check IHI history record to compare IHI changes." +
  //                       "<br/><br/>Attention: There are " +
  //                       duplicateIHICount +
  //                       "patient accounts with the same IHI Number. <br /> Patient UIN: " +
  //                       duplicateIHIPatientUIN +
  //                       "<br/>Please check and report to HI Service."
  //                     );
  //                     setShowModal(true);
  //                   } else {
  //                     setModalText(
  //                       "IHI details have been changed and saved. <br/>Check IHI history record to compare IHI changes."
  //                     );
  //                     setModalTitle("IHI refreshed");
  //                     setShowModal(true);
  //                   }
  //                 },
  //                 failureCallback: err => {
  //                   setIsProcessing(false);
  //                   //setServerErrorMsg(err.message);
  //                 }
  //               });
  //             }
  //           }
  //
  //           // can not get IHI number
  //           if (
  //             res.data.data.searchIHIResult.serviceMessages &&
  //             res.data.data.searchIHIResult.serviceMessages.serviceMessage
  //           ) {
  //             const serviceMessage =
  //               res.data.data.searchIHIResult.serviceMessages.serviceMessage;
  //             setModalTitle("IHI validation failed");
  //             setModalText(
  //               `<p style=color:#f00>Can not get an IHI number.</p>
  //               Reason:${removeSpecificWordFromHIResponse(
  //                 serviceMessage.reason
  //               )}`
  //             );
  //             setShowModal(true);
  //           }
  //         } else {
  //           setModalTitle("IHI validation failed");
  //           setModalText(
  //             `Something went wrong. <br/>Please try it again later.`
  //           );
  //           setShowModal(true);
  //         }
  //         // if (medicareStatus) {
  //         // let date = new Date();
  //         // date = date.toLocaleString("fr-CA").split(" ")[0];
  //         // setLastVerificationDate(date);
  //         // setLastVerificationCode(medicareStatus.status.code);
  //         // setMedicareStatus(medicareStatus);
  //         // setVerifyMedicareCardModal(true);
  //         // } else {
  //         //   setPatientVerificationFailedRes(res.data.data);
  //         //   setPatientVerificationFailedModal(true);
  //         // }
  //       },
  //       failureCallback: err => {
  //         setIsProcessing(false);
  //         // setServerErrorMsg(err.message);
  //       }
  //     });
  //   } else {
  //     let emptyElements = "";
  //     emptyElementArray.forEach(
  //       item => (emptyElements = emptyElements + " " + item)
  //     );
  //     setModalTitle("Can not validate IHI");
  //     setModalText(
  //       `Please check personal information before IHI validation. <br/>
  //       These following fields must be provided: "First Name", "Last Name", "Date of Birth", "Gender". <br/>
  //       Also at least one of the following groups of information must be provide: <br/>
  //       1. "IHI Number" (Recommended) <br/>
  //       2. "Medicare Number" and "Reference Number"(Recommended) <br/>
  //       3. "Unit/Street Number", "Street Name", "Suburb", "State", "Postcode"`
  //     );
  //     setShowModal(true);
  //   }
  // };

  // const checkDuplicatePatientDemographicInfo = (values, IHISearchType) => {
  //   const formData = new FormData();
  //   formData.append("patientId", props.data._id);
  //   formData.append("firstName", values.firstNameForHIService);
  //   formData.append("lastName", values.lastNameForHIService);
  //   formData.append("DOB", getFormattedDate(values.dob));
  //   formData.append("gender", values.gender);
  //   formData.append("postcode", values.postCode);
  //   formData.append("streetName", values.streetName);
  //
  //   setIsProcessing(true);
  //   setApiCallParams({
  //     reqType: "POST",
  //     reqUrl: checkDuplicatePatientDemographicInfoApiRoute,
  //     dataObj: formData,
  //     successCallback: res => {
  //       setIsProcessing(false);
  //       const result = res.data.data;
  //       const duplicatePatientCount = Object.keys(result).length;
  //       if (duplicatePatientCount > 1) {
  //         let duplicatePatientUIN = "";
  //         result.forEach(item => {
  //           duplicatePatientUIN = duplicatePatientUIN + item.patientId + " ";
  //         });
  //         setModalTitle("Duplicate Patient Accounts");
  //         setModalText(
  //           "There are " +
  //           duplicatePatientCount +
  //           " duplicate patient accounts. <br /> Patient UIN: " +
  //           duplicatePatientUIN +
  //           "<br />Please remove the duplicate accounts first."
  //         );
  //         setShowModal(true);
  //       } else if (duplicatePatientCount === 1) {
  //         let duplicatePatientUIN = "";
  //         result.forEach(item => {
  //           duplicatePatientUIN = duplicatePatientUIN + item.patientId + " ";
  //         });
  //         setModalTitle("Duplicate Patient Accounts");
  //         setModalText(
  //         "Patient's Medicare details are already registered with<br /> Patient UIN: " +
  //         duplicatePatientUIN +
  //         "<br />Please remove the duplicate account,<br /> or obtain correct Medicare details."
  //         );
  //         setShowModal(true);
  //       } else {
  //         // search IHI number if there is no duplicate patient account
  //         searchIHI_V2(values, IHISearchType);
  //       }
  //     },
  //     failureCallback: err => {
  //       setIsProcessing(false);
  //       // setServerErrorMsg(err.message);
  //     }
  //   });
  // };

  const checkDuplicatePatientDemographicInfo_v2 = values => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("patientId", props.data._id);
      formData.append("firstName", values.firstNameForHIService);
      formData.append("lastName", values.lastNameForHIService);
      formData.append("DOB", getFormattedDate(values.dob));
      formData.append("gender", values.gender);
      formData.append("postcode", values.postCode);
      formData.append("streetName", values.streetName);

      setIsProcessing(true);
      setApiCallParams({
        reqType: "POST",
        reqUrl: checkDuplicatePatientDemographicInfoApiRoute,
        dataObj: formData,
        successCallback: res => {
          setIsProcessing(false);
          console.log("Res: ", res);
          const result = res.data.data;
          const duplicatePatientCount = Object.keys(result).length;
          console.log("duplicatePatientCount: ", duplicatePatientCount);
          if (duplicatePatientCount > 1) {
            let duplicatePatientUIN = "";
            result.forEach(item => {
              duplicatePatientUIN = duplicatePatientUIN + item.patientId + " ";
            });
            setModalTitle("Duplicate Patient Accounts");
            setModalText(
              "There are " +
              duplicatePatientCount +
              " duplicate patient accounts. <br /> Patient UIN: " +
              duplicatePatientUIN +
              "<br />Please remove the duplicate accounts first."
            );
            setShowModal(true);

            reject();
          } else if (duplicatePatientCount === 1) {
            let duplicatePatientUIN = "";
            result.forEach(item => {
              duplicatePatientUIN = duplicatePatientUIN + item.patientId + " ";
            });
            setModalTitle("Duplicate Patient Accounts");
            setModalText(
              "There is 1 duplicate patient account. <br /> Patient UIN: " +
              duplicatePatientUIN +
              "<br />Please remove the duplicate account first."
            );
            setShowModal(true);

            reject();
          } else {
            // search IHI number if there is no duplicate patient account
            resolve();
          }
        },
        failureCallback: err => {
          setIsProcessing(false);
          // setServerErrorMsg(err.message);
          reject(err);
        },
        showErrPopup: false
      });
    });
  };

  const searchIHI_V2 = (values, IHISearchType) => {
    const isValidInput = HIServiceUtil.checkValidInputOfSearchIHI(values);
    console.log("isValidInput", isValidInput);

    if (!isValidInput.basicInfo) {
      setModalTitle("Can not validate IHI");
      setModalText(
        `Please check the basic personal information before IHI validation. <br/> 
        These following fields must be provided: "First Name", "Last Name", "Date of Birth", "Gender". <br/>`
      );
      setShowModal(true);
    } else if (
      !isValidInput.IHINumber &&
      !isValidInput.Medicare &&
      // !isValidInput.DVA &&
      !isValidInput.address
    ) {
      setModalTitle("Can not validate IHI");
      setModalText(
        `Please check the personal information before IHI validation. <br/>
        At least one of the following groups of information must be provide: <br/>
        1. "Medicare Number" and "Reference Number"(Recommended) <br/>
        2. "Unit/Street Number", "Street Name", "Suburb", "State", "Postcode"`
      );
      setShowModal(true);
    } else {
      let criteriaType = ""; // use criteriaType to determine the IHI search method

      if (IHISearchType) {
        if (isValidInput[IHISearchType]) {
          criteriaType = HIServiceUtil.searchIHICriteriaType[IHISearchType];

          console.log("criteriaType", criteriaType);
        } else {
          setModalTitle("Can not validate IHI");
          setModalText(
            `Please check the relevant information if search by ${IHISearchType}.`
          );
          setShowModal(true);
          return;
        }
      } else {
        if (isValidInput.IHINumber) {
          // validate IHI by IHINumber
          criteriaType = HIServiceUtil.searchIHICriteriaType.IHINumber;
        } else if (isValidInput.Medicare) {
          // search IHI by Medicare
          criteriaType = HIServiceUtil.searchIHICriteriaType.Medicare;
          // } else if (isValidInput.DVA) {
          //   // search IHI by DVA
          //   criteriaType = HIServiceUtil.searchIHICriteriaType.DVA;
        } else if (isValidInput.address) {
          // search IHI by address
          criteriaType = HIServiceUtil.searchIHICriteriaType.address;
        }
      }

      checkDuplicatePatientDemographicInfo_v2(values)
        .then(res => {
          console.log("Promise res", res);
          const payload = HIServiceUtil.getSearchIHIPayload(
            criteriaType,
            values
          );
          payload.patientID = props.data._id;
          payload.serviceType = HIServiceType.SEARCH_IHI;

          // const formData = new FormData();
          // formData.append("HIInfo", JSON.stringify(payload));
          const dataToSend = {
            HIInfo: payload
          };

          setIsProcessing(true);
          setApiCallParams({
            reqType: "POST",
            reqUrl: requestHIServiceSearchIHIApiRoute,
            dataObj: dataToSend,
            successCallback: res => {
              setIsProcessing(false);
              setHILocked(true);
              setIsHIServiceInvoked(true);
              setProfileUsedForHIService({
                fname: values.firstNameForHIService,
                lname: values.lastNameForHIService,
                gender: values.gender,
                dob: getFormattedDate(values.dob),
                medNo: values.medNo,
                refNo: values.refNo
                // DVANumber: values.DVANumber
              });
              console.log("res", res);

              if (
                !res.data ||
                !res.data.data ||
                !res.data.data.searchIHIResult
              ) {
                // there is no searchIHIResult field in response
                setModalTitle("IHI Validation");
                setModalText(
                  `Something went wrong. <br/>Please try it again later.`
                );
                setShowModal(true);
              } else if (
                res.data.data.searchIHIResult.serviceMessages &&
                res.data.data.searchIHIResult.serviceMessages.serviceMessage
              ) {
                // there is serviceMessages filed in searchIHIResult in response
                const { IHIUpdatedAt } = res.data.data;
                const {
                  ihiNumber: IHINumber = "",
                  ihiRecordStatus: IHIRecordStatus = "",
                  ihiStatus: IHINumberStatus = ""
                } = res.data.data.searchIHIResult;

                if (
                  IHINumber &&
                  IHINumber.length === 16 &&
                  IHINumber !== formik.values.IHINumber
                ) {
                  //check duplicate IHI Number when IHINumber changes
                  checkIsDuplicateIHINumber(IHINumber);
                }

                let isIHIChanged = false;
                if (
                  (formik.values.IHINumber ||
                    formik.values.IHINumberStatus ||
                    formik.values.IHIRecordStatus ||
                    formik.values.IHIUpdateAt) &&
                  (formik.values.IHINumber !== IHINumber ||
                    formik.values.IHINumberStatus !== IHINumberStatus ||
                    formik.values.IHIRecordStatus !== IHIRecordStatus)
                ) {
                  isIHIChanged = true;
                }

                formik.values.IHINumber = IHINumber || "";
                formik.values.IHINumberStatus = IHINumberStatus || "";
                formik.values.IHIRecordStatus = IHIRecordStatus || "";
                formik.values.IHIUpdateAt = IHIUpdatedAt || "";

                const serviceMessage =
                  res.data.data.searchIHIResult.serviceMessages.serviceMessage;
                const isResolved =
                  res.data.data.searchIHIResult.serviceMessages.serviceMessage
                    .code === "01611";

                let text = removeSpecificWordFromHIResponse(
                  serviceMessage.reason
                );

                if (
                  serviceMessage.reason.indexOf(
                    `This IHI record has an 'Expired' IHI status`
                  ) > -1
                ) {
                  text =
                    "The Healthcare Individual record contains an EXPIRED IHI Status.";
                }
                if (
                  serviceMessage.reason.indexOf(
                    `This IHI record has a 'Retired' IHI status`
                  ) > -1
                ) {
                  text =
                    "The Healthcare Individual record contains a RETIRED IHI Status.";
                }

                setModalTitle("IHI Validation");
                if (isResolved) {
                  setModalText(
                    `${
                      isIHIChanged
                        ? "Attention: IHI has been changed. Check access logs for details."
                        : ""
                    }<p>${text}</p>
                    Please use the returned IHI Number to check again.`
                  );
                } else {
                  setModalText(
                    `${
                      isIHIChanged
                        ? "Attention: IHI has been changed. Check access logs for details."
                        : ""
                    }<p style=color:#f00>${text}</p>`
                  );
                }
                setShowModal(true);

                // if (res.data.data.searchIHIResult.ihiStatus) {
                //   const { IHIUpdatedAt } = res.data.data;
                //   const {
                //     ihiNumber: IHINumber = "",
                //     ihiRecordStatus: IHIRecordStatus = "",
                //     ihiStatus: IHINumberStatus = ""
                //   } = res.data.data.searchIHIResult;

                //   if (
                //     IHINumber &&
                //     IHINumber.length === 16 &&
                //     IHINumber !== formik.values.IHINumber
                //   ) {
                //     //TODO: check duplicate IHI Number when IHINumber changes
                //     checkIsDuplicateIHINumber(IHINumber);
                //   }
                //   formik.values.IHINumber = IHINumber || "";
                //   formik.values.IHINumberStatus = IHINumberStatus || "";
                //   formik.values.IHIRecordStatus = IHIRecordStatus || "";
                //   formik.values.IHIUpdateAt = IHIUpdatedAt || "";
                // }
              } else {
                // there is searchIHIResult in response, and there is no serviceMessages in searchIHIResult
                const { IHIUpdatedAt, isAlert, alertMessage } = res.data.data;
                const {
                  ihiNumber: IHINumber,
                  ihiRecordStatus: IHIRecordStatus,
                  ihiStatus: IHINumberStatus
                } = res.data.data.searchIHIResult;

                // if (IHINumber !== formik.values.IHINumber) {
                //   console.log("check duplicate IHINumber ========== ");
                //   checkIsDuplicateIHINumber(IHINumber);
                // }
                checkIsDuplicateIHINumber(IHINumber);

                let isIHIChanged = false;
                if (
                  (formik.values.IHINumber ||
                    formik.values.IHINumberStatus ||
                    formik.values.IHIRecordStatus ||
                    formik.values.IHIUpdateAt) &&
                  (formik.values.IHINumber !== IHINumber ||
                    formik.values.IHINumberStatus !== IHINumberStatus ||
                    formik.values.IHIRecordStatus !== IHIRecordStatus)
                ) {
                  isIHIChanged = true;
                }

                formik.values.IHINumber = IHINumber || "";
                formik.values.IHINumberStatus = IHINumberStatus || "";
                formik.values.IHIRecordStatus = IHIRecordStatus || "";
                formik.values.IHIUpdateAt = IHIUpdatedAt || "";

                if (isAlert) {
                  setModalTitle("IHI Validation");
                  setModalText(
                    `${
                      isIHIChanged
                        ? "Attention: IHI has been changed. Check access logs for details."
                        : ""
                    }<p style=color:#f00>${removeSpecificWordFromHIResponse(
                      alertMessage
                    )}</p>`
                  );
                  setShowModal(true);
                } else {
                  setModalTitle("IHI Validation");
                  setModalText(
                    `${
                      isIHIChanged
                        ? "Attention: IHI has been changed. Check access logs for details."
                        : ""
                    }<p style=color:#28a745>IHI successfully validated.</p>`
                  );
                  setShowModal(true);
                }
              }
            },
            failureCallback: err => {
              setIsProcessing(false);
              // setModalText(
              //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
              // );
              // setShowModal(true);
              // setServerErrorMsg(err.message);
            },
          });
        })
        .catch(err => {
          console.error("checkDuplicatePatientDemographicInfo_v2 error", err);
          setModalTitle("Duplicate Patient Accounts");
          const split = err.data.split(":");
          const duplicateUIN = split.length > 1 ? split[1] : err;
          setModalText(
            "Patient's IHI details are already registered with<br /> Patient UIN: " +
            duplicateUIN +
            "<br />Please remove the duplicate account,<br /> or obtain correct IHI details."
          );
          setShowModal(true);

        });
    }
  };

  const removeSpecificWordFromHIResponse = str => {
    const newStr = str.replace(/\(INFORMATION\)\s*|\(ERROR\)\s*/g, "");
    return newStr;
  };

  const checkIsDuplicateIHINumber = IHINumber => {
    const formData = new FormData();
    formData.append("patientId", props.data._id);
    formData.append("IHINumber", IHINumber);

    setIsProcessing(true);
    setApiCallParams({
      reqType: "POST",
      reqUrl: checkIsDuplicateIHINumberApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);
        const result = res.data.data;

        console.log("check duplicate IHI result", result);

        const duplicateIHICount = Object.keys(result).length;

        if (duplicateIHICount > 0) {
          let duplicateIHIPatientUIN = "";
          result.map(item => {
            duplicateIHIPatientUIN =
              duplicateIHIPatientUIN + item.patientId + " ";
          });
          setIHINumberDuplicateModalText(
            "Attention: There are " +
            duplicateIHICount +
            "patient accounts with the same IHI Number. <br /> Patient UIN: " +
            duplicateIHIPatientUIN +
            "<br/>Please check and report to HI Service."
          );
          setIHINumberDuplicateModal(true);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setServerErrorMsg(err.message);
      }
    });
  };

  const showIHIHistory = () => {
    const patientID = props.data._id;

    setIsProcessing(true);
    setApiCallParams({
      reqType: "GET",
      reqUrl: getIHIHistoryRecordApiRoute,
      params: { patientID },
      successCallback: res => {
        setIsProcessing(false);
        console.log("showIHIHistory res", res);
        setIHIHistoryRecordData(res.data.data);
        setIHIHistoryRecordModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        //setServerErrorMsg(err.message);
      }
    });
  };

  const resetPassword = () => {
    const patientId = props.data._id;
    console.log("resetP > ", { patientId, props: props.data });

    setIsProcessing(true);
    setApiCallParams({
      reqType: "POST",
      reqUrl: resetPatientPassword,
      dataObj: { patientId },
      successCallback: res => {
        setIsProcessing(false);
        console.log("password reset success", res);
        setShowResetPasswordModal(false);

        setModalText("Password Reset Successfully")
        setModalTitle("Password Reset")
        setShowModal(true);
      },
      failureCallback: err => {
        console.log("password reset fail", err);
        setIsProcessing(false);
      }
    });
  };

  const handleSearchByIHI = () => {
    console.log("handleSearchByIHI");
    searchIHI_V2(formik.values, "IHINumber");
  };
  const handleSearchByMedicare = () => {
    console.log("handleSearchByMedicare");
    searchIHI_V2(formik.values, "Medicare");
  };
  // const handleSearchByDVA = () => {
  //   console.log("handleSearchByDVA");
  //   searchIHI_V2(formik.values, "DVA");
  // };
  const handleSearchByAddress = () => {
    console.log("handleSearchByAddress");
    searchIHI_V2(formik.values, "address");
  };

  const checkPatientOver18 = (isDependent, dob) => {
    if (isDependent) {
      let dependentDOB = formatDate(dob) || new Date();
      dependentDOB = getFormattedDate(dependentDOB);
      const years = moment().diff(moment(dependentDOB, "DD-MM-YYYY"), "years", true);
      setIsFieldsDisabled(years >= 17 ? false : true);
    } else {
      setIsFieldsDisabled(false);
    }
  };

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <CustomModal
        openModal={verifyMedicareCardModal}
        cancelEvent={() => {
          setVerifyMedicareCardModal(false);
        }}
        title="Patient Verification Completed"
        modalBodyContent={
          <VerifyMedicareCardResponse medicareStatus={medicareStatus} />
        }
        useOneButton={true}
        cancelText="Close"
        noFooterButtons={true}
      />
      <CustomModal
        openModal={patientVerificationFailedModal}
        cancelEvent={() => {
          setPatientVerificationFailedModal(false);
        }}
        title="Patient Verification Failed"
        modalBodyContent={
          <VerifyMedicareCardFailedResponse
            failedResponse={patientVerificationFailedRes}
          />
        }
        useOneButton={true}
        cancelText="Close"
        noFooterButtons={true}
      />
      <CustomModal
        openModal={IHIHistoryRecordModal}
        cancelEvent={() => {
          setIHIHistoryRecordModal(false);
        }}
        title="IHI Access Logs"
        modalBodyContent={
          <IHIHistoryRecord IHIHistoryRecordData={IHIHistoryRecordData} />
        }
        size="lg"
        useOneButton={true}
        cancelText="Close"
        noFooterButtons={true}
      />
      <CustomModal
        openModal={IHINumberDuplicateModal}
        cancelText="OKAY"
        cancelEvent={() => {
          setIHINumberDuplicateModal(false);
          setIHINumberDuplicateModalText("");
        }}
        title="IHI Number Duplicate Information"
        modalBodyContent={
          <p
            className="mb-0"
            dangerouslySetInnerHTML={{
              __html: IHINumberDuplicateModalText
            }}
          ></p>
        }
        useOneButton={true}
      />
      <div className={isProcessing ? "disableContainer" : ""}>
        <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
          <Error>{serverErrorMsg}</Error>
          <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>UIN</label> {
              props.data && props.data.dependents && props.data.dependents.length ? (
                <i className="fas fa-users ml-1 insta-link-orange"></i>
              ) : ("")
            }
              <ICInput
                name="uin"
                type="text"
                value={formik.values.uin}
                disabled
              />
            </div>
            <div className="form-group col-md-6">
              <label>Registration Date</label>
              <ICInput
                name="regDate"
                type="text"
                value={formik.values.regDate}
                disabled
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="form-group col-md-4">
              <label>First Name</label>
              <span className="error">*</span>
              <ICInput
                name="firstNameForHIService"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstNameForHIService}
                error={
                  formik.touched.firstNameForHIService &&
                  formik.errors.firstNameForHIService
                    ? true
                    : false
                }
                helperText={
                  formik.touched.firstNameForHIService &&
                  formik.errors.firstNameForHIService
                    ? formik.errors.firstNameForHIService
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-4">
              <label>Middle Name</label>
              <ICInput
                name="mname"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mname}
                error={
                  formik.touched.mname && formik.errors.mname ? true : false
                }
                helperText={
                  formik.touched.mname && formik.errors.mname
                    ? formik.errors.mname
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-4">
              <label>Last Name</label>
              <span className="error">*</span>
              <ICInput
                name="lastNameForHIService"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastNameForHIService}
                error={
                  formik.touched.lastNameForHIService &&
                  formik.errors.lastNameForHIService
                    ? true
                    : false
                }
                helperText={
                  formik.touched.lastNameForHIService &&
                  formik.errors.lastNameForHIService
                    ? formik.errors.lastNameForHIService
                    : ""
                }
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="form-group col-md-4">
              <label>
                First Name Display<span className="error">*</span>
              </label>
              <ICInput
                name="fname"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.fname}
                error={
                  formik.touched.fname && formik.errors.fname ? true : false
                }
                helperText={
                  formik.touched.fname && formik.errors.fname
                    ? formik.errors.fname
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-4">
              <label>
                Last Name Display<span className="error">*</span>
              </label>
              <ICInput
                name="lname"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lname}
                error={
                  formik.touched.lname && formik.errors.lname ? true : false
                }
                helperText={
                  formik.touched.lname && formik.errors.lname
                    ? formik.errors.lname
                    : ""
                }
              />
            </div>
          </div>

          <div className="form-row mt-4">
            <div className="form-group col-md-4">
              <label>
                Date of Birth <span className="error">*</span>
              </label>
              <br />
              <KeyboardDatePicker
                name="dob"
                autoOk
                className="w-100"
                variant="inline"
                mask="__-__-____"
                format="DD-MM-YYYY"
                value={formik.values.dob}
                onChange={date => {
                  formik.setFieldValue("dob", date);
                }}
                error={formik.touched.dob && formik.errors.dob ? true : false}
                helperText={
                  formik.touched.dob && formik.errors.dob
                    ? formik.errors.dob
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-4">
              <label>
                Gender <span className="error">*</span>
              </label>
              <TextField
                name="gender"
                className="w-100"
                select
                value={formik.values.gender}
                SelectProps={{
                  native: true
                }}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.gender && formik.errors.gender ? true : false
                }
                helperText={
                  formik.touched.gender && formik.errors.gender
                    ? formik.errors.gender
                    : ""
                }
              >
                <option disabled value="0">
                  Select Gender
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </TextField>
            </div>
            <div className="form-group col-md-4">
              <label>
                Credit Card Number <span className="error">*</span>
              </label>
              <TextField
                name="ccn"
                className="w-100"
                select
                SelectProps={{
                  native: true
                }}
                disabled={isFieldsDisabled}
              >
                <option>View Credit Card Number</option>
                {formik.values.ccn.length === 0 && (
                  <option>No Credit Card details found</option>
                )}
                {formik.values.ccn.length > 0 &&
                  formik.values.ccn.map((cc, i) => (
                    <option
                      key={i}
                      value={"XXXX-XXXX-XXXX-" + cc.lastFourDigit}
                    >
                      {"XXXX-XXXX-XXXX-" + cc.lastFourDigit}
                    </option>
                  ))}
              </TextField>
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>
                Phone Number <span className="error">*</span>
              </label>
              <ICPhoneInput
                name="phoneNo"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phoneNo}
                error={
                  formik.touched.phoneNo && formik.errors.phoneNo ? true : false
                }
                helperText={
                  formik.touched.phoneNo && formik.errors.phoneNo
                    ? formik.errors.phoneNo
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
            { !props.data?.isDependent && <div className="form-group col-md-6">
              <label>
                Email <span className="error">*</span>
              </label>
              <ICInput
                name="email"
                type="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                error={
                  formik.touched.email && formik.errors.email ? true : false
                }
                helperText={
                  formik.touched.email && formik.errors.email
                    ? formik.errors.email
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>}
          </div>
          <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>
                Unit/Street Number <span className="error">*</span>
              </label>
              <ICInput
                name="un"
                type="text"
                value={formik.values.un}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.un && formik.errors.un ? true : false}
                helperText={
                  formik.touched.un && formik.errors.un ? formik.errors.un : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
            <div className="form-group col-md-6">
              <label>
                Street Name <span className="error">*</span>
              </label>
              <ICInput
                name="streetName"
                type="text"
                value={formik.values.streetName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.streetName && formik.errors.streetName
                    ? true
                    : false
                }
                helperText={
                  formik.touched.streetName && formik.errors.streetName
                    ? formik.errors.streetName
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="form-group col-md-4">
              <label>
                Suburb <span className="error">*</span>
              </label>
              <ICInput
                name="suburb"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.suburb}
                error={
                  formik.touched.suburb && formik.errors.suburb ? true : false
                }
                helperText={
                  formik.touched.suburb && formik.errors.suburb
                    ? formik.errors.suburb
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
            <div className="form-group col-md-4">
              <label>
                State <span className="error">*</span>
              </label>
              <TextField
                name="state"
                className="w-100"
                select
                value={formik.values.state}
                SelectProps={{
                  native: true
                }}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.state && formik.errors.state ? true : false
                }
                helperText={
                  formik.touched.state && formik.errors.state
                    ? formik.errors.state
                    : ""
                }
                disabled={isFieldsDisabled}
              >
                <option disabled>Select State</option>
                {props.statesList.map((state, i) => (
                  <option key={i} value={state.stateId}>
                    {state.stateId}
                  </option>
                ))}
              </TextField>
            </div>
            <div className="form-group col-md-4">
              <label>
                Postcode <span className="error">*</span>
              </label>
              <ICInput
                name="postCode"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.postCode}
                error={
                  formik.touched.postCode && formik.errors.postCode
                    ? true
                    : false
                }
                helperText={
                  formik.touched.postCode && formik.errors.postCode
                    ? formik.errors.postCode
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="form-group col-md-5">
              <label>Medicare Number</label>
              <CustomMaskInput
                name="medNo"
                type="text"
                mask="9999 99999 9"
                value={formik.values.medNo}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.medNo && formik.errors.medNo ? true : false
                }
                helperText={
                  formik.touched.medNo && formik.errors.medNo
                    ? formik.errors.medNo
                    : ""
                }
              />
              {lastVerificationDate && (
                <span
                  className={
                    lastVerificationCode === 0 ? "text-success" : "text-danger"
                  }
                  style={{ fontSize: "12px" }}
                >
                  Last Verification Date:{" "}
                  {lastVerificationDate.split("-")[2] +
                    "-" +
                    lastVerificationDate.split("-")[1] +
                    "-" +
                    lastVerificationDate.split("-")[0]}
                </span>
              )}
            </div>

            <div className="form-group col-md-5">
              <label>Reference Number</label>
              <ICInput
                name="refNo"
                type="text"
                value={formik.values.refNo}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.refNo && formik.errors.refNo ? true : false
                }
                helperText={
                  formik.touched.refNo && formik.errors.refNo
                    ? formik.errors.refNo
                    : ""
                }
              />
            </div>

            {!medicareStatus ? (
              <div className="form-group col-md-1">
                <RefreshButton
                  onClick={() => checkForDuplicateAttachment(formik.values)}
                />
              </div>
            ) : (
              <div className="form-group col-md-1">
                {medicareStatus.status && medicareStatus.status.code === 0 ? (
                  <i
                    className="fas fa-check-circle"
                    style={{
                      color: "green",
                      fontSize: "16px",
                      margin: "28px 0 0 12px"
                    }}
                  />
                ) : (
                  <i
                    className="fas fa-times-circle"
                    style={{
                      color: "red",
                      fontSize: "16px",
                      margin: "28px 0 0 12px"
                    }}
                  />
                )}
              </div>
            )}
          </div>

          {/* 
          <div className="form-row mt-4">
            <div className="form-group col-12">
              <label>DVA Number</label>
              <ICInput
                name="DVANumber"
                type="text"
                value={formik.values.DVANumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.DVANumber && formik.errors.DVANumber
                    ? true
                    : false
                }
                helperText={
                  formik.touched.DVANumber && formik.errors.DVANumber
                    ? formik.errors.DVANumber
                    : ""
                }
              />
            </div>
          </div> 
          */}

          <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>IHI Number</label>
              <ICInput
                name="IHINumber"
                type="number"
                disabled={HILocked}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.IHINumber}
                error={
                  formik.touched.IHINumber && formik.errors.IHINumber
                    ? true
                    : false
                }
                helperText={
                  formik.touched.IHINumber && formik.errors.IHINumber
                    ? formik.errors.IHINumber
                    : ""
                }
              />
              {formik.values.IHIUpdateAt && (
                <span className="text-success" style={{ fontSize: "12px" }}>
                  Updated:{" "}
                  {new Date(formik.values.IHIUpdateAt).toLocaleString("es-CL")}
                </span>
              )}
            </div>

            <div className="form-group col-md-6">
              <div className="form-row mt-2">
                {true && (
                  <div className="form-group col-2">
                    <RefreshButton
                      onClick={() => searchIHI_V2(formik.values)}
                    />
                  </div>
                )}
                {HILocked && (
                  <div className="form-group col-2">
                    <LockedButton onClick={() => setHILocked(false)} />
                  </div>
                )}
                {!HILocked && (
                  <div className="form-group col-2">
                    <LockOpenButton onClick={() => setHILocked(true)} />
                  </div>
                )}

                {true && (
                  <div className="form-group col-2">
                    <HistoryRecordButton onClick={() => showIHIHistory()} />
                  </div>
                )}
                {/* {true && (
                  <div className="form-group col-2">
                    <EllipsisButton
                      onClick={() => setMultiIHISearch(!multiIHISearch)}
                    />
                  </div>
                )} */}
                {true && (
                  <div className="form-group col-2">
                    <IHISearchDropdown
                      handleSearchByIHI={handleSearchByIHI}
                      handleSearchByMedicare={handleSearchByMedicare}
                      // handleSearchByDVA={handleSearchByDVA}
                      handleSearchByAddress={handleSearchByAddress}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>IHI Number Status</label>
              <ICInput
                name="IHINumberStatus"
                type="text"
                disabled
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.IHINumberStatus}
              />
            </div>
            <div className="form-group col-md-6">
              <label>IHI Record Status</label>
              <ICInput
                name="IHIRecordStatus"
                type="text"
                disabled
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.IHIRecordStatus}
              />
            </div>
          </div>

          <p className="mb-0">
            <b>Emergency Contact 1</b>
          </p>
          <div className="form-row mt-2">
            <div className="form-group col-md-6">
              <label>Contact Name</label>
              <ICInput
                name="ecName1"
                type="text"
                value={formik.values.ecName1}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.ecName1 && formik.errors.ecName1 ? true : false
                }
                helperText={
                  formik.touched.ecName1 && formik.errors.ecName1
                    ? formik.errors.ecName1
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
            <div className="form-group col-md-6">
              <label>Contact Number</label>

              <ICPhoneInput
                name="ecNumber1"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ecNumber1}
                error={
                  formik.touched.ecNumber1 && formik.errors.ecNumber1
                    ? true
                    : false
                }
                helperText={
                  formik.touched.ecNumber1 && formik.errors.ecNumber1
                    ? formik.errors.ecNumber1
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
          </div>
          <p className="mb-0">
            <b>Emergency Contact 2</b>
          </p>
          <div className="form-row mt-2">
            <div className="form-group col-md-6">
              <label>Contact Name</label>
              <ICInput
                name="ecName2"
                type="text"
                value={formik.values.ecName2}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.ecName2 && formik.errors.ecName2 ? true : false
                }
                helperText={
                  formik.touched.ecName2 && formik.errors.ecName2
                    ? formik.errors.ecName2
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
            <div className="form-group col-md-6">
              <label>Contact Number</label>
              <ICPhoneInput
                name="ecNumber2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ecNumber2}
                error={
                  formik.touched.ecNumber2 && formik.errors.ecNumber2
                    ? true
                    : false
                }
                helperText={
                  formik.touched.ecNumber2 && formik.errors.ecNumber2
                    ? formik.errors.ecNumber2
                    : ""
                }
                disabled={isFieldsDisabled}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>Profile Pic</label>
              <div className="d-flex flex-row">
                <img
                  className="rounded-circle user-img mr-4"
                  src={formik.values.previewImg}
                  alt="user-img"
                />
                &nbsp;&nbsp;
                <p>
                  <input
                    className="mb-2 pt-3"
                    type="file"
                    onChange={event => {
                      if (validateFile(event.currentTarget.files[0])) {
                        formik.setFieldValue(
                          "profilePic",
                          event.currentTarget.files[0]
                        );

                        formik.setFieldValue(
                          "previewImg",
                          URL.createObjectURL(event.currentTarget.files[0])
                        );
                      }
                    }}
                  />
                  <br />
                  <span style={{ fontSize: "12px" }}>
                    JPG, GIF or PNG. Max size of 2MB
                  </span>
                  <br />
                  <Error class="error">{fileError}</Error>
                </p>
              </div>
            </div>
            <div className="form-group col-md-6">
              <label>Additional Notes Regarding This Patient </label>
              <TextField
                name="notes"
                className="w-100"
                rows="5"
                multiline
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.notes}
                error={
                  formik.touched.notes && formik.errors.notes ? true : false
                }
                helperText={
                  formik.touched.notes && formik.errors.notes
                    ? formik.errors.notes
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-6">
              <ICCheckbox
                //style={{ padding: 0 }}
                name="optOutMarketingEmails"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.optOutMarketingEmails}
                checked={formik.values.optOutMarketingEmails}
                label="Opt-Out Marketing Emails"
                inputProps={{ "aria-label": "primary checkbox" }}
                disabled={isFieldsDisabled}
              />
            </div>

            <div className="form-group col-md-6 row">
              <button
                onClick={() => setShowResetPasswordModal(true)}
                type="button"
                className="btn m-0 ic-btn-grey"
              >
                Reset Password
              </button>
              { props.data?.isDependent &&
              <button
                onClick={() => setShowSeparateModal(true)}
                type="button"
                className="btn m-0 ml-2 insta-button-primary"
              >
                Separate Dependent
              </button>
              }
            </div>
          </div>
          <br />
          <p className="mb-0 d-flex justify-content-center">
            <Button title="Save" type="submit" />
          </p>
        </form>
      </div>
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showModal}
        title={modalTitle}
        className="text-left"
        cancelEvent={() => {
          setShowModal(false);
          setModalText("");
        }}
        modalBodyContent={
          <p
            className="mb-0"
            dangerouslySetInnerHTML={{
              __html: modalText
            }}
          ></p>
        }
      />

      <CustomModal
        okayText="Reset"
        cancelText="Cancel"
        openModal={showResetPasswordModal}
        title={"Reset Password"}
        className="text-left"
        cancelEvent={() => {
          setShowResetPasswordModal(false);
        }}
        okayEvent={() => {
          resetPassword();
        }}
        modalBodyContent={
          <p
            className="mb-0"
            dangerouslySetInnerHTML={{
              __html: "Are you sure you want to reset the password?"
            }}
          ></p>
        }
      />

      <CustomModal
        okayText="Separate Dependent"
        cancelText="Cancel"
        openModal={showSeparateModal}
        title="Separate Dependent"
        className="text-left"
        cancelEvent={() => {
          setShowSeparateModal(false);
        }}
        okayEvent={() => {
          newEmailFormik.submitForm();
        }}
        modalBodyContent={
           <div className="p-3">
             <form noValidate onSubmit={newEmailFormik.handleSubmit}>
                <ICInput
                  label="New Email"
                  placeholder="New Email"
                  name="newEmail"
                  type="text"
                  error={
                    formik.touched.newEmail && formik.errors.newEmail ? true : false
                  }
                  helperText={
                    formik.touched.newEmail && formik.errors.newEmail
                      ? formik.errors.newEmail
                      : ""
                  }
                  onChange={newEmailFormik.handleChange}
                  onBlur={newEmailFormik.handleBlur}
                  value={newEmailFormik.values.newEmail} />
             </form>
              </div>
        }
      />
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </Fragment>
  );
};

export default PatientProfileForm;

PatientProfileForm.propTypes = {
  data: PropTypes.object,
  statesList: PropTypes.array.isRequired,
  successEvent: PropTypes.func.isRequired
};
